import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { UserNoPassword } from 'types';

export const deleteUser = (userId: number) => {
  return axios.delete(`/api/users/${userId}`);
};

type UseDeleteUserOptions = {
  config?: MutationConfig<typeof deleteUser>;
};

export const useDeleteUser = ({ config }: UseDeleteUserOptions) => {
  return useMutation({
    onMutate: async (deletedUserId: number) => {
      await queryClient.cancelQueries(['users']);

      const previousUsers = queryClient.getQueryData<UserNoPassword[]>([
        'users',
      ]);

      queryClient.setQueryData(
        ['users'],
        previousUsers?.filter((user) => user.id !== deletedUserId)
      );

      return { previousUsers };
    },
    onError: (_, __, context: any) => {
      if (context?.previousUsers) {
        queryClient.setQueryData(['users'], context.previousUsers);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['users']);
    },
    ...config,
    mutationFn: deleteUser,
  });
};
